import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./register.css";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      register: {
        email: "",
        password: "",
        passwordconfirmed: ""
      }
    };
  }

  handleUpdateText = formType => event => {
    const { name, value } = event.target;
    const newState = Object.assign({}, this.state);
    newState[formType][name] = value;
    this.setState(newState);
  };

  setJwtState = jwt => {
    localStorage.setItem("jwt", jwt);
    console.log("state is forming");
    // this.props.handleLogin(true);
  };

  registerSubmit = formType => event => {
    event.preventDefault();
    // const URL = `https://littleflowers.herokuapp.com/auth/${formType}`;
    const URL = `http://localhost:5000/auth/${formType}`;
    const registerState = Object.assign({}, this.state[formType]);
    axios
      .post(URL, registerState)
      .then(res => {
        console.log("This is a test for register to clear!");
        this.setJwtState(formType, res.data.JWT);
        this.setState({
          register: {
            email: "",
            password: "",
            passwordconfirmed: ""
          }
        });
      })
      .catch(err => {
        this.setState({
          register: {
            email: "",
            password: "",
            passwordconfirmed: ""
          }
        });
        console.warn(err);
      });
  };

  render() {
    return (
      <div>
        <div className="Register-container">
          <form className="Register-form">
            <input
              required
              type="email"
              name="email"
              placeholder="Enter users email"
              value={this.state.register.email}
              onChange={this.handleUpdateText("register")}
            />
            <br />
            <input
              required
              type="password"
              name="password"
              placeholder="Enter password"
              value={this.state.register.password}
              onChange={this.handleUpdateText("register")}
            />
            <br />
            <input
              required
              type="password"
              name="passwordconfirmed"
              placeholder="Confirm password"
              value={this.state.register.passwordconfirmed}
              onChange={this.handleUpdateText("register")}
            />
            <br />
            <button type="submit" onClick={this.registerSubmit("register")}>
              Register
            </button>
            <div className="link">
              <Link to="/login">Don't have an account? Login here!</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Register;
